import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MuiStack from '@mui/material/Stack';
import { extractSystemStyles } from '@famly/mf_system_system-props';
import { useDataProps } from '@famly/mf_ts-utils_data-aria-props';
export const Stack = (props) => {
    const { component, children, direction = 'row', spacing, ref, ...rest } = props;
    const dataProps = useDataProps(rest);
    const { sx, nonSystemProps } = extractSystemStyles(rest);
    const _props = { ...dataProps, sx, component, direction, spacing, useFlexGap: true, ...nonSystemProps };
    return (_jsx(MuiStack, { ..._props, ref: ref, children: children }));
};
Stack.displayName = 'Stack';
export const createStack = (outerProps) => {
    return (innerProps) => {
        const props = { ...outerProps, ...innerProps };
        return _jsx(Stack, { ...props });
    };
};
